const PAYMENT_NUMBER = { display: 'Payment Number', value: 'payment-number', sort: 'PAYMENT_NUMBER' };
const PAYMENT_TYPE = { display: 'Type', value: 'payment-type' };
const PARTY_NAME = { display: 'Party Name', value: 'party-name' };
const PARTY_NAMES = { display: 'Party Names', value: 'party-names' };
const DATE = { display: 'Created Date', value: 'date', sort: 'DATE' };
const AMOUNT = { display: 'Amount', value: 'amount', sort: 'AMOUNT' };
const STATUS = { display: 'Status', value: 'status' };
const PAYMENT_METHOD = { display: 'Payment Method', value: 'payment-method' };
const VENDOR = { display: 'Vendor', value: 'vendor' };
const VENDOR_ID = { display: 'Vendor ID', value: 'vendor-id' };

export const AllPaymentTable = [
    PAYMENT_NUMBER,
    PAYMENT_TYPE,
    PARTY_NAMES,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD,
];

export const IndividualPaymentTable = [
    PAYMENT_NUMBER,
    PARTY_NAME,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD,
];

export const MultiPartyPaymentTable = [
    PAYMENT_NUMBER,
    PAYMENT_TYPE,
    PARTY_NAMES,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD
];

export const MultipleClaimantsPaymentTable = [
    PAYMENT_NUMBER,
    PARTY_NAMES,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD
];

export const ClaimantVendorPaymentTable = [
    PAYMENT_NUMBER,
    PARTY_NAMES,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD
];

export const VendorPaymentTable = [
    PAYMENT_NUMBER,
    VENDOR,
    VENDOR_ID,
    DATE,
    AMOUNT,
    STATUS,
    PAYMENT_METHOD,
];